import React, { useEffect, useState } from "react";
import API from '../Services/Designation'
import API1 from "../Services/AccessRight";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import css from "../Styles/table1.css"


const Designation = () => {
    const [name, setName] = useState()
    const [errors, setErrors] = useState({});
    const [designation, setDesignation] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const perPage = 10;
    const [id, setId] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [checkedAccessRights, setCheckedAccessRights] = useState({});
    const [accessRight, setAccessRight] = useState([]);
    const [createdDate, setCreatedDate] = useState("")
    const [status, setStatus] = useState("")

    const validateFields = () => {
        const errors = {};
        if (!name?.trim()) {
            errors.name = "Name is required";
        } else if (!/^[a-zA-Z]/.test(name)) {
            errors.name = "Name must start with a letter";
        } else if (!/^[a-zA-Z0-9 _-]+$/.test(name)) {
            errors.name = "Enter a Valid Name";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const addDesignationData = async () => {
        if (!validateFields()) return;
        const selectedRoutes = Object.keys(checkedAccessRights)
            .filter((key) => checkedAccessRights[key])
            .map((id) => parseInt(id, 10));
        if (selectedRoutes.length === 0) {
            toast.error("Please select at least one access right.");
            return;
        }
        try {
            const payload = { name };
            const response = await API.addDesignationList(payload);
            if (response?.status !== 200) {
                toast.error(response?.data?.message || "Designation not added. Please try again later.");
                return;
            }
            const designation_id = response?.data?.data?.id;
            if (selectedRoutes.length > 0) {
                const accessPayload = {
                    designation_id,
                    route_id: selectedRoutes,
                    type: "route",
                    is_active: 1,
                };
                const response1 = await API1.create_Access_Right(accessPayload);
                if (response1?.status === 200) {
                    toast.success(response1?.data?.message || "Permission Added successfully!");
                } else {
                    toast.error(response1?.data?.message || "Failed to add permissions.");
                }
            } else {
                toast.success(response?.data?.message || "Designation Added successfully!");
            }
            setTimeout(() => window.location.reload(), 2000);
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login")
            }
            toast.error(error?.response?.data?.message || "An error occurred. Please try again.");
        }
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "name":
                setName(value);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        getDesignationList();
        bindAccessRight();
    }, [currentPage]);

    const getDesignationList = async () => {
        try {
            const data = await API.bindDesignation({
                pageNumber: currentPage,
                limit: perPage
            });
           // console.log("desination data...", data?.data?.data?.count)
            setDesignation(data?.data?.data?.rows);
            setTotalRecords(data?.data?.data?.count);
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status === 403) {
                    window.location.replace("/Login")
                } else if (status === 500) {
                    toast.error("Internal server error. Please try again later.");
                }
                else {
                    toast.error(error.response.data?.message || "An error occurred while fetching the designation list.");
                }
            } else if (error.request) {
                toast.error("No response from server");
            } else {
                toast.error("Something went wrong. Please try again.");
            }
        }
    };


    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            //  getDesignationList();
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };
    const handleStatusToggle = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeDesignationStatus(id, updatedStatus);
            if (response.status === 200) {
                setDesignation((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Designation ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
            } else {
                // console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };

    const handleGetData = async (designationId) => {
      //  console.log("designation id...", designationId)
        try {
            const response = await API.bindDesignation({ id: designationId });
            const fetchedData = response?.data?.data?.rows?.[0];
          //  console.log("fetch data", fetchedData)
            const response1 = await API1.get_Employee_Access_Right({
                designation_id: designationId
            });
            const accessRights = Object.values(response1?.data?.data || {}).flat();
           // console.log('accessRights', accessRights);
            const checkedRights = accessRights.reduce((acc, item) => {
                acc[item.id] = true;
                return acc;
            }, {});
            setCheckedAccessRights(checkedRights);
            if (fetchedData) {
                setId(fetchedData.id);
                setName(fetchedData.name);
                setCreatedDate(fetchedData?.createdAt);
                setStatus(fetchedData?.is_active);
                setIsEditing(true);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            } else {
                toast.error("Failed to fetch designation details.");
            }
        } catch (error) {
            if (error.response.data === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const handleViewData = async (designationId) => {
       // console.log("designation id...", designationId)
        try {
            const response = await API.bindDesignation({ id: designationId });
            const fetchedData = response?.data?.data?.rows?.[0];
           // console.log("fetch data", fetchedData)

            if (fetchedData) {
                setId(fetchedData.id);
                setName(fetchedData.name);
                setCreatedDate(fetchedData?.createdAt);
                setStatus(fetchedData?.is_active);
                // setIsEditing(true);
                // window.scrollTo({
                //     top: 0,
                //     behavior: 'smooth',
                // });
            } else {
                toast.error("Failed to fetch designation details.");
            }
        } catch (error) {
            if (error.response.data === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    }
    const updateDesignationData = async () => {
        if (!validateFields()) return;
        const selectedRoutes = Object.keys(checkedAccessRights)
            .filter((key) => checkedAccessRights[key])
            .map((id) => parseInt(id, 10));

        if (selectedRoutes.length === 0) {
            toast.error("Please select at least one access right.");
            return;
        }
        try {
            const payload = { name };
            const response = await API.updateDesignation(id, payload);
            const payload1 = {
                designation_id: id,
                route_id: selectedRoutes,
                type: "route",
                is_active: 1
            }
            const response1 = await API1.create_Access_Right(payload1);
            if (response1?.status === 200) {
                toast.success(response1?.data?.message || "Designation updated successfully!");
                setTimeout(() => window.location.reload(), 2000);
                getDesignationList()
            } else {
                toast.error(response1?.data?.message || "Failed to update designation. Please try again.");
            }
        } catch (error) {
            console.error("Error updating designation:", error);
            toast.error(error.response?.data?.message || "Designation not added. Please try again later.");
            if (error.status === 403) {
                window.location.replace("/Login");
            }
            // toast.error("An unexpected error occurred. Please try again later.");
        }
    };


    const handleCancelEdit = () => {
        setName('');
        setId(null);
        setIsEditing(false);
        window.location.reload();
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        if (isEditing) {
            await updateDesignationData();
        } else {
            await addDesignationData();
        }
    };
    const bindAccessRight = async () => {
        try {
            const response = await API1.Bind_Access_Right({});
            const modules = response.data.data;
           // console.log("module data...", module)
            const groupedModules = modules.reduce((acc, module) => {
                if (!acc[module.name]) {
                    acc[module.name] = [];
                }
                if (Array.isArray(module.RoutesModel)) {
                    acc[module.name] = [...acc[module.name], ...module.RoutesModel];
                }
                return acc;
            }, {});
            setAccessRight(groupedModules);
        } catch (error) {
            console.error("Error fetching access rights:", error);
        }
    };

    const handleAccessRightChange = (id) => {
        setCheckedAccessRights((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };
    const handleModuleToggle = (pages) => {
        //  console.log('ffffffffffff', pages[0].id);
        const updatedRights = { ...checkedAccessRights };
        const allChecked = pages.every((page) => checkedAccessRights[page.id]);

        pages.forEach((page) => {
            updatedRights[page.id] = !allChecked;
        });
       // console.log('updatedRights', updatedRights)
        setCheckedAccessRights(updatedRights);
    };

    return (
        <div>
            <div >
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Add Designation</h4>
                            <div className="forms-sample">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="form-group">
                                            <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtname"
                                                placeholder="Name"
                                                value={name}
                                                onChange={(e) => handleFieldChange(e, "name")}
                                            />
                                            {errors.name && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.name}</span>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="container mt-2">
                    <div className="row">
                        {Object.entries(accessRight).map(([moduleName, routes]) => (
                            <div key={moduleName} className="col-md-6 col-lg-4 mb-3">
                                <div className="card h-100 shadow-sm border-primary">
                                    <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between">
                                        <div>
                                            <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                checked={routes.every((page) => checkedAccessRights[page.id])}
                                                onChange={() => handleModuleToggle(routes)}
                                                style={{ border: '2px solid black' }}
                                            />
                                            <strong>{moduleName}</strong>
                                        </div>
                                    </div>

                                    <div className="card-body">
                                        {Array.isArray(routes) && routes.length > 0 ? (
                                            <div className="mt-1">
                                                {routes.map((page) => (
                                                    <div key={page.id} className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input me-2"
                                                            id={`checkbox-${moduleName}-${page.id}`}
                                                            value={page.route}
                                                            checked={checkedAccessRights[page.id] || false}
                                                            onChange={() => handleAccessRightChange(page.id)}
                                                            style={{ border: '2px solid black' }}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor={`checkbox-${moduleName}-${page.id}`}
                                                        >
                                                            {page.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="text-muted">No access rights available</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="mt-3 mb-3">
                        <button type="submit" className="btn btn-primary me-2" onClick={handleSubmit}>
                            {isEditing ? "Update" : "Submit"}
                        </button>
                        <button className="btn btn-light" onClick={handleCancelEdit}>Cancel</button>
                    </div>
                </div>


            </div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Total Designation</h4>
                    </div>

                    <div className="card-body">
                        <table className="table table-bordered text-center">
                            <thead>
                                <tr>
                                    <th style={{ width: "100px" }}>SrNo</th>
                                    <th style={{ width: "300px" }}>Action</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {designation.map((item, index) => (
                                    // <tr key={item.id}>
                                    <tr
                                        key={item.id}
                                        data-active={item?.is_active ? "true" : "false"}
                                    >
                                        <td>{(currentPage - 1) * perPage + index + 1}</td>

                                        <td>
                                            <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                <ul className="navbar-nav navbar-nav-right">
                                                    <li className="nav-item nav-profile1">
                                                        <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <div className="nav-profile-text1">
                                                                <p className="mb-1 text-black">
                                                                </p>
                                                            </div>
                                                        </span>
                                                        <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                        <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                            <a className="dropdown-item">
                                                                <button onClick={() => handleViewData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                    View
                                                                </button>
                                                            </a>
                                                            <div className="dropdown-divider"></div>
                                                            <a className="dropdown-item">

                                                                <button className="btn btn-primary btn-sm"
                                                                    onClick={() => handleGetData(item.id)} >Edit</button>
                                                            </a>
                                                            <div className="dropdown-divider"></div>
                                                            <a className="dropdown-item">
                                                                <button
                                                                    className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                    onClick={() => handleStatusToggle(item.id, item.is_active)}
                                                                >
                                                                    {item.is_active ? "De-Activate" : "Activate"}
                                                                </button>
                                                            </a>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>{item.name}</td>
                                        <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                        <td>{moment(item?.createdAt).format("DD-MM-YYYY")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center mt-4">
                                {/* Previous Button */}
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>
                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button className="page-link" onClick={() => handlePageChange(page)}>
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                {/* Next Button */}
                                <li
                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            <ToastContainer />
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Designation Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Created Date</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{name}</td>
                                                            <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default Designation;